import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { reportNewClaim } from 'src/app/my-sedgwick/functions/report-newclaim';
import { scrollToElement } from 'src/app/shared';
import { SubSink } from 'subsink';
import { DynamicEventBindService, LogService } from '../..';
import { ExternalLinkDialogComponent } from '../../../shared/components/controls/dialog/external-link-dialog.component';
import { ConfigurationService } from '../../services/configuration.service';
import { LearningCenterService } from '../../services/learning-center.service';
import { OpenFileService } from '../../services/openfile.service';
import { Session } from '../../services/session.service';
import { StickyMenuComponent } from '../../../shared/components/controls/sticky-menu/sticky-menu.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-learning-center-wc',
    template: `
    <div #dynamicContentContainer class="tw-w-full tw-flex">
      <!-- CONTENT -->
      <div class="tw-grow">
        <!-- INTRODUCTION -->
        @if (isIntroduction) {
          <h2
            class="app-lc-header-2"
            id="lc-intro"
            role="heading"
            >
            {{ 'Introduction' | translation: translationRequest }}
          </h2>
        }
        <div class="app-lc-text">
          <p [innerHTML]="learningCenter.introductionResults[0]?.value"></p>
        </div>
        @if (isWhatisWC) {
          <h2
            [innerHTML]="learningCenter.introductionResults[1].value"
            class="app-lc-header-2"
            id="lc-what"
            role="heading"
          ></h2>
        }
        <div class="app-lc-text tw-flex">
          <div class="tw-grow">
            <p [innerHTML]="learningCenter.introductionResults[2]?.value"></p>
            <p [innerHTML]="learningCenter.introductionResults[3]?.value"></p>
          </div>
          @if (isWhatisWC) {
            <div
              class="tw-flex-none app-pl2 tw-hidden md:tw-block"
              >
              <img
                src="./assets/images/img_LC_introphone_desktop.webp"
                width="69"
                height="100"
                alt=""
                aria-hidden="true"
                role="img"
                />
              </div>
            }
          </div>
          <!-- INTRODUCTION END-->
          <!-- BENEFITS CALC-->
          @if (isBenefitsCalc) {
            <h2
              class="app-lc-header-2"
              id="lc-ben"
              role="heading"
              >
              {{ 'Benefits Calculations' | translation: translationRequest }}
            </h2>
          }
          <div class="app-lc-text">
            <p [innerHTML]="learningCenter.benefits[0]?.value"></p>
            <p [innerHTML]="learningCenter.benefits[1]?.value"></p>
          </div>
          <!-- BENEFITS CALC END-->
          <!-- SUBMITTING CLAIM INFO-->
    
          <h2 class="app-lc-header-2" id="lc-sub" role="heading">
            {{ 'Submitting Claim Information' | translation: translationRequest }}
          </h2>
          @if (isMgr) {
            <div>
              <app-learning-center-section
                label="{{ learningCenter.submittingclaiminformations[0]?.value }}"
                icon="1"
                layout="bullet"
                >
                <p
                [innerHTML]="
                  learningCenter?.submittingclaiminformations[1].value
                "
                ></p>
                @if (learningCenter?.submittingclaiminformations[2]?.value) {
                  <span
                    #dynamicContentContainer
                    [innerHTML]="
                      learningCenter?.submittingclaiminformations[2].value
                    "
                  ></span>
                }
              </app-learning-center-section>
              <app-learning-center-section
                label="{{ learningCenter.submittingclaiminformations[3]?.value }}"
                icon="2"
                layout="bullet"
                >
                <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[4]?.value
                "
                ></p>
                @if (!claimClosed && isShown) {
                  <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[5]?.value
                "
                  ></p>
                }
              </app-learning-center-section>
              <app-learning-center-section
                label="{{ learningCenter.submittingclaiminformations[6].value }}"
                icon="3"
                layout="bullet"
                >
                <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[7]?.value
                "
                ></p>
                <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[9]?.value
                "
                ></p>
              </app-learning-center-section>
              @if (this.learningCenter.submittingclaiminformations[10].value) {
                <app-learning-center-section
              label="{{
                learningCenter.submittingclaiminformations[10]?.value
              }}"
                  icon="4"
                  layout="bullet"
                  >
                  <div
                    class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                    >
                    @if (
                      this.claimConfigService.getFeatureAccess(
                      'UploadDocuments'
                      ) &&
                      isMgr &&
                      isShown
                      ) {
                      <app-learning-center-section
                        class="tw-basis-1/4 app-color-teal"
                        layout="icon-small"
                        icon="upload_file"
                        >
                        <a
                          tabindex="0"
                          label="Documents"
                          class="go-to-documents-upload"
                          (click)="redirectToDocUpload()"
                          >{{ 'Upload documents' | translation: translationRequest }}</a
                          >
                        </app-learning-center-section>
                      }
                      @if (
                        isMgr &&
                        learningCenter.submittingclaiminformations[13]?.value
                        ) {
                        <app-learning-center-section
                          class="tw-basis-1/4"
                          layout="icon-small"
                          icon="mail"
                          >
                          {{ 'Mail' | translation: translationRequest }}:<br />
                          <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[13]?.value
                    "
                          ></span>
                        </app-learning-center-section>
                      }
                      @if (learningCenter.submittingclaiminformations[14]?.value) {
                        <app-learning-center-section
                          class="tw-basis-1/4"
                          layout="icon-small"
                          icon="fax"
                          >
                          {{ 'Fax' | translation: translationRequest }}:<br />
                          <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[14]?.value
                    "
                          ></span>
                        </app-learning-center-section>
                      }
                      @if (learningCenter.submittingclaiminformations[12]?.value) {
                        <app-learning-center-section
                          class="tw-basis-1/4"
                          layout="icon-small"
                          icon="laptop_mac"
                          >
                          {{ 'Email' | translation: translationRequest }}:<br />
                          <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[12]?.value
                    "
                          ></span>
                        </app-learning-center-section>
                      }
                    </div>
                  </app-learning-center-section>
                }
              </div>
            } @else {
              <div>
                <app-learning-center-section
                  label="{{ learningCenter.submittingclaiminformations[0]?.value }}"
                  icon="1"
                  layout="bullet"
                  >
                  <p
                [innerHTML]="
                  learningCenter?.submittingclaiminformations[1].value
                "
                  ></p>
                  @if (learningCenter?.submittingclaiminformations[2]?.value) {
                    <span
                      #dynamicContentContainer
                      [innerHTML]="
                        learningCenter?.submittingclaiminformations[2].value
                      "
                    ></span>
                  }
                </app-learning-center-section>
                <app-learning-center-section
                  label="{{ learningCenter.submittingclaiminformations[3]?.value }}"
                  icon="2"
                  layout="bullet"
                  >
                  <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[4]?.value
                "
                  ></p>
                  @if (!claimClosed && isShown) {
                    <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[5]?.value
                "
                    ></p>
                  }
                </app-learning-center-section>
                <app-learning-center-section
                  label="{{ learningCenter.submittingclaiminformations[6].value }}"
                  icon="3"
                  layout="bullet"
                  >
                  <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[7]?.value
                "
                  ></p>
                  @if (!claimClosed && isShown) {
                    @if (learningCenter.submittingclaiminformations[8]?.value) {
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[8]?.value
                        "
                      ></p>
                    }
                  }
                  <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[9]?.value
                "
                  ></p>
                </app-learning-center-section>
                @if (this.learningCenter.submittingclaiminformations[10].value) {
                  <app-learning-center-section
              label="{{
                learningCenter.submittingclaiminformations[10]?.value
              }}"
                    icon="4"
                    layout="bullet"
                    >
                    <div
                      class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                      >
                      @if (
                        this.claimConfigService.getFeatureAccess(
                        'UploadDocuments'
                        ) &&
                        !claimClosed &&
                        isShown
                        ) {
                        <app-learning-center-section
                          class="tw-basis-1/4 app-color-teal"
                          layout="icon-small"
                          icon="upload_file"
                          >
                          <a
                            tabindex="0"
                            label="Documents"
                            class="go-to-documents-upload"
                            (click)="redirectToDocUpload()"
                            >{{ 'Upload documents' | translation: translationRequest }}</a
                            >
                          </app-learning-center-section>
                        }
                        @if (learningCenter.submittingclaiminformations[13]?.value) {
                          <app-learning-center-section
                            class="tw-basis-1/4"
                            layout="icon-small"
                            icon="mail"
                            >
                            {{ 'Mail' | translation: translationRequest }}:<br />
                            <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[13]?.value
                    "
                            ></span>
                          </app-learning-center-section>
                        }
                        @if (learningCenter.submittingclaiminformations[14]?.value) {
                          <app-learning-center-section
                            class="tw-basis-1/4"
                            layout="icon-small"
                            icon="fax"
                            >
                            {{ 'Fax' | translation: translationRequest }}:<br />
                            <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[14]?.value
                    "
                            ></span>
                          </app-learning-center-section>
                        }
                        @if (learningCenter.submittingclaiminformations[12]?.value) {
                          <app-learning-center-section
                            class="tw-basis-1/4"
                            layout="icon-small"
                            icon="laptop_mac"
                            >
                            {{ 'Email' | translation: translationRequest }}:<br />
                            <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[12]?.value
                    "
                            ></span>
                          </app-learning-center-section>
                        }
                      </div>
                    </app-learning-center-section>
                  }
                </div>
              }
              <!-- SUBMITTING CLAIM INFO END-->
              <!-- WHATS NEXT-->
              @if (isWhatsNext) {
                <h2
                  class="app-lc-header-2"
                  role="heading"
                  id="lc-next"
                  >
                  {{ "What's Next?" | translation: translationRequest }}
                </h2>
              }
              <div class="app-lc-text tw-flex">
                <div class="tw-grow">
                  @if (isMgr) {
                    @if (isWhatsNext) {
                      <div
                        class="right-wrap app-pl2 tw-hidden md:tw-block"
                        >
                        <img
                          src="./assets/images/img_LC_WhatsNext_computer.webp"
                          width="141"
                          height="100"
                          alt=""
                          role="img"
                          />
                        </div>
                      }
                      <p [innerHTML]="learningCenter.whatsnexts[0]?.value"></p>
                      @if (
                        (isShown && learningCenter.whatsnexts[3]?.value) ||
                        (learningCenter.whatsnexts[4]?.value &&
                        learningCenter.whatsnexts[5]?.value) ||
                        (learningCenter.whatsnexts[7]?.value &&
                        learningCenter.whatsnexts[8]?.value &&
                        learningCenter.whatsnexts[9]?.value &&
                        learningCenter.whatsnexts[9]?.value) ||
                        (this.claimConfigService.getConfigFeatureAccess(
                        'notificationpreferences'
                        ) &&
                        learningCenter.whatsnexts[5]?.value &&
                        learningCenter.whatsnexts[6]?.value)
                        ) {
                        <p
                          [innerHTML]="learningCenter.whatsnexts[1]?.value"
                          >
                          >
                        </p>
                      }
                      <div>
                        @if (isShown && learningCenter.whatsnexts[3]?.value) {
                          <app-learning-center-section
                            label="{{ learningCenter.whatsnexts[2]?.value }}"
                            icon="laptop_mac"
                            layout="icon"
                            >
                            <p [innerHTML]="learningCenter.whatsnexts[3]?.value"></p>
                          </app-learning-center-section>
                        }
                      </div>
                      <div>
                        @if (learningCenter.whatsnexts[8]?.value) {
                          <app-learning-center-section
                            label="{{ learningCenter.whatsnexts[6]?.value }}"
                            icon="contact_phone"
                            layout="icon"
                            >
                            <p
                    [innerHTML]="
                      learningCenter.whatsnexts[7]?.value +
                      ' ' +
                      learningCenter.whatsnexts[8]?.value +
                      ' ' +
                      learningCenter.whatsnexts[9]?.value
                    "
                            ></p>
                          </app-learning-center-section>
                        }
                      </div>
                    } @else {
                      @if (isWhatsNext) {
                        <div
                          class="right-wrap app-pl2 tw-hidden md:tw-block"
                          >
                          <img
                            src="./assets/images/img_LC_WhatsNext_computer.webp"
                            width="141"
                            height="100"
                            alt=""
                            role="img"
                            />
                          </div>
                        }
                        <p [innerHTML]="learningCenter.whatsnexts[0]?.value"></p>
                        @if (
                          (isShown && learningCenter.whatsnexts[3]?.value) ||
                          (learningCenter.whatsnexts[4]?.value &&
                          learningCenter.whatsnexts[5]?.value) ||
                          (learningCenter.whatsnexts[7]?.value &&
                          learningCenter.whatsnexts[8]?.value &&
                          learningCenter.whatsnexts[9]?.value &&
                          learningCenter.whatsnexts[9]?.value) ||
                          (this.claimConfigService.getConfigFeatureAccess(
                          'notificationpreferences'
                          ) &&
                          learningCenter.whatsnexts[5]?.value &&
                          learningCenter.whatsnexts[6]?.value)
                          ) {
                          <p
                            [innerHTML]="learningCenter.whatsnexts[1]?.value"
                            >
                            >
                          </p>
                        }
                        <div>
                          @if (
                            !claimClosed &&
                            isShown &&
                            learningCenter.whatsnexts[3]?.value
                            ) {
                            <app-learning-center-section
                              label="{{ learningCenter.whatsnexts[2]?.value }}"
                              icon="laptop_mac"
                              layout="icon"
                              >
                              <p [innerHTML]="learningCenter.whatsnexts[3]?.value"></p>
                            </app-learning-center-section>
                          }
                        </div>
                        <div>
                          @if (
                            this.claimConfigService.getConfigFeatureAccess(
                            'notificationpreferences'
                            ) && learningCenter.whatsnexts[5]?.value
                            ) {
                            <app-learning-center-section
                              label="{{ learningCenter.whatsnexts[4]?.value }}"
                              icon="chat"
                              layout="icon"
                              >
                              <p [innerHTML]="learningCenter.whatsnexts[5]?.value"></p>
                            </app-learning-center-section>
                          }
                        </div>
                        <div>
                          @if (learningCenter.whatsnexts[8]?.value) {
                            <app-learning-center-section
                              label="{{ learningCenter.whatsnexts[6]?.value }}"
                              icon="contact_phone"
                              layout="icon"
                              >
                              <p
                    [innerHTML]="
                      learningCenter.whatsnexts[7]?.value +
                      ' ' +
                      learningCenter.whatsnexts[8]?.value +
                      ' ' +
                      learningCenter.whatsnexts[9]?.value
                    "
                              ></p>
                            </app-learning-center-section>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <!-- WHATS NEXT END-->
                  <!-- MED TREATMENT-->
                  @if (isMedical) {
                    <h2
                      class="app-lc-header-2"
                      role="heading"
                      id="lc-med"
                      >
                      {{ 'Medical Treatment and Providers' | translation: translationRequest }}
                    </h2>
                  }
                  <div class="app-lc-text tw-flex">
                    <div class="tw-grow">
                      @if (isMedical) {
                        <div
                          class="right-wrap app-pl2 tw-hidden md:tw-block"
                          >
                          <img
                            src="./assets/images/img_LC_MedTreatment_desktop.webp"
                            width="176"
                            height="200"
                            alt=""
                            role="img"
                            />
                          </div>
                        }
                        @if (isMgr) {
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[0]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[2]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[3]?.value
                "
                          ></p>
                          <div
                            class="tw-w-full tw-flex tw-flex-wrap tw-flex-col md:tw-flex-row  tw-justify-items-stretch"
                            >
                            @if (learningCenter.medicaltreatmentandproviders[4]?.value) {
                              <app-learning-center-section
                                class="tw-basis-1/3"
                                layout="icon-small"
                                icon="fax"
                                >
                                <p
                    [innerHTML]="
                      learningCenter.medicaltreatmentandproviders[4]?.value
                    "
                                ></p>
                              </app-learning-center-section>
                            }
                            @if (learningCenter.medicaltreatmentandproviders[5]?.value) {
                              <app-learning-center-section
                                class="tw-basis-1/3"
                                layout="icon-small"
                                icon="mail"
                                >
                                <p
                    [innerHTML]="
                      learningCenter.medicaltreatmentandproviders[5]?.value
                    "
                                ></p>
                              </app-learning-center-section>
                            }
                          </div>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[8]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[9]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[10]?.value
                "
                          ></p>
                        } @else {
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[0]?.value
                "
                          ></p>
                          @if (!claimClosed && isShown) {
                            <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[1]?.value
                "
                            ></p>
                          }
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[2]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[3]?.value
                "
                          ></p>
                          <div
                            class="tw-w-full tw-flex tw-flex-wrap tw-flex-col md:tw-flex-row  tw-justify-items-stretch"
                            >
                            @if (learningCenter.medicaltreatmentandproviders[4]?.value) {
                              <app-learning-center-section
                                class="tw-basis-1/3"
                                layout="icon-small"
                                icon="mail"
                                >
                                <p
                    [innerHTML]="
                      learningCenter.medicaltreatmentandproviders[4]?.value
                    "
                                ></p>
                              </app-learning-center-section>
                            }
                            @if (learningCenter.medicaltreatmentandproviders[5]?.value) {
                              <app-learning-center-section
                                class="tw-basis-1/3"
                                layout="icon-small"
                                icon="fax"
                                >
                                <p
                    [innerHTML]="
                      learningCenter.medicaltreatmentandproviders[5]?.value
                    "
                                ></p>
                              </app-learning-center-section>
                            }
                          </div>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[6]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[7]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[8]?.value
                "
                          ></p>
                          <p
                [innerHTML]="
                  learningCenter.medicaltreatmentandproviders[9]?.value
                "
                          ></p>
                        }
                      </div>
                    </div>
                    <!-- MED TREATMENT END-->
                    <!-- RETURN TO WORK-->
    
                    @if (isReturnToWork) {
                      <h2
                        class="app-lc-header-2"
                        role="heading"
                        id="lc-rtw"
                        >
                        {{ 'Returning to Work' | translation: translationRequest }}
                      </h2>
                    }
                    <div class="app-lc-text tw-flex">
                      <div class="tw-grow">
                        @if (isReturnToWork) {
                          <div
                            class="left-wrap app-pr2 img-pd-btm tw-hidden lg:tw-block"
                            >
                            <img
                              src="./assets/images/img_LC_RTW_desktop.webp"
                              width="270"
                              height="210"
                              alt=""
                              />
                            </div>
                          }
                          @if (isMgr) {
                            <p>
                              <span
                                ><b
                                [innerHTML]="learningCenter.returntoworks[0]?.value"
                              ></b></span
                              ><br />
                            </p>
                            <p [innerHTML]="learningCenter.returntoworks[1]?.value"></p>
                            <p>
                              <span
                                ><b
                                [innerHTML]="learningCenter.returntoworks[2]?.value"
                              ></b></span
                              ><br />
                            </p>
                            <p [innerHTML]="learningCenter.returntoworks[3]?.value"></p>
                            <p>
                              <span
                                ><b
                                [innerHTML]="learningCenter.returntoworks[4]?.value"
                              ></b></span
                              ><br />
                            </p>
                            <p [innerHTML]="learningCenter.returntoworks[5]?.value"></p>
                          } @else {
                            <p>
                              <span
                                ><b
                                [innerHTML]="learningCenter.returntoworks[0]?.value"
                              ></b></span
                              ><br />
                            </p>
                            <p [innerHTML]="learningCenter.returntoworks[1]?.value"></p>
                            <p [innerHTML]="learningCenter.returntoworks[3]?.value"></p>
                            <p>
                              <span
                                ><b
                                [innerHTML]="learningCenter.returntoworks[4]?.value"
                              ></b></span
                              ><br />
                            </p>
                            <p [innerHTML]="learningCenter.returntoworks[5]?.value"></p>
                          }
                        </div>
                      </div>
                      <!-- RETURN TO WORK END-->
    
                      <!-- THINGS TO KNOW-->
    
                      @if (isThingsToKnow) {
                        <h2
                          class="app-lc-header-2"
                          role="heading"
                          id="lc-things"
                          >
                          {{ 'Things to Know' | translation: translationRequest }}
                        </h2>
                      }
                      <div class="app-lc-text tw-flex">
                        <div class="tw-grow">
                          @if (isThingsToKnow) {
                            <app-learning-center-section
                              label="{{ learningCenter.thingstoknows[0]?.value }}"
                              icon="schedule"
                              layout="icon"
                              >
                            </app-learning-center-section>
                          }
                          @if (learningCenter.thingstoknows[1]?.value) {
                            <b>
                              {{ learningCenter.thingstoknows[1]?.value }}
                            </b>
                          }
                          @if (isMgr) {
                            <ul class="tw-list-disc tw-list-inside">
                              @if (learningCenter.thingstoknows[2]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[2]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[3]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[3]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[4]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[4]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[5]?.value) {
                                <li
                                  [innerHTML]="learningCenter.thingstoknows[5]?.value"
                                ></li>
                              }
                              @if (learningCenter.thingstoknows[6]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[6]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[7]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[7]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[8]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[8]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[9]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[9]?.value }}
                                </li>
                              }
                            </ul>
                          } @else {
                            <ul class="tw-list-disc tw-list-inside">
                              @if (learningCenter.thingstoknows[2]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[2]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[3]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[3]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[4]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[4]?.value }}
                                </li>
                              }
                              @if (
                                !claimClosed &&
                                isShown &&
                                learningCenter.thingstoknows[5]?.value
                                ) {
                                <li
                                  [innerHTML]="learningCenter.thingstoknows[5]?.value"
                                ></li>
                              }
                              @if (learningCenter.thingstoknows[6]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[6]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[7]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[7]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[8]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[8]?.value }}
                                </li>
                              }
                              @if (learningCenter.thingstoknows[9]?.value) {
                                <li>
                                  {{ learningCenter.thingstoknows[9]?.value }}
                                </li>
                              }
                            </ul>
                          }
                        </div>
                      </div>
                      <div id='endOfElement' tabindex="-1">&nbsp;</div>
                      <!-- THINGS TO KNOW END-->
                    </div>
                    <!-- RHS MENU -->
                    <div
                      class="tw-hidden lg:tw-block tw-flex-none tw-max-w-[220px] app-lc-menu"
                      >
                      <app-sticky-menu
                        #stickyMenu
                        [currentSection]="currentSection"
                        (sectionChange)="onSectionChange($event)"
                        >
                        <div class="app-pt2">
                          <div class="app-lc-sticky-link"><b>{{ "Workers' Compensation" | translation: translationRequest }}</b></div>
                          @if (isIntroduction) {
                            <div
                              class="app-lc-sticky-link"
                              [class.active-sidelink]="currentSection === 'lc-intro'"
                              >
                              <a tabindex="0" (click)="scrollToSection('lc-intro')"
                                >{{ 'Introduction' | translation: translationRequest }}</a
                                >
                              </div>
                            }
                            @if (isWhatisWC) {
                              <div
                                class="app-lc-sticky-link"
                                [class.active-sidelink]="currentSection === 'lc-what'"
                                >
                                <a tabindex="0" (click)="scrollToSection('lc-what')"
                                  >{{ "What is a Workers' Compensation Claim" | translation: translationRequest }}</a
                                  >
                                </div>
                              }
                              @if (isBenefitsCalc) {
                                <div
                                  class="app-lc-sticky-link"
                                  [class.active-sidelink]="currentSection === 'lc-ben'"
                                  >
                                  <a tabindex="0" (click)="scrollToSection('lc-ben')"
                                    >{{ 'Benefits Calculations' | translation: translationRequest }}</a
                                    >
                                  </div>
                                }
                                <div
                                  class="app-lc-sticky-link"
                                  [class.active-sidelink]="currentSection === 'lc-sub'"
                                  >
                                  <a tabindex="0" (click)="scrollToSection('lc-sub')"
                                    >{{ 'Submitting Claim Information' | translation: translationRequest }}</a
                                    >
                                  </div>
                                  @if (isWhatsNext) {
                                    <div
                                      class="app-lc-sticky-link"
                                      [class.active-sidelink]="currentSection === 'lc-next'"
                                      >
                                      <a tabindex="0" (click)="scrollToSection('lc-next')"
                                        >{{ "What's Next" | translation: translationRequest }}</a
                                        >
                                      </div>
                                    }
                                    @if (isMedical) {
                                      <div
                                        class="app-lc-sticky-link"
                                        [class.active-sidelink]="currentSection === 'lc-med'"
                                        >
                                        <a tabindex="0" (click)="scrollToSection('lc-med')"
                                          >{{ 'Medical Treatment and Providers' | translation: translationRequest }}</a
                                          >
                                        </div>
                                      }
                                      @if (isReturnToWork) {
                                        <div
                                          class="app-lc-sticky-link"
                                          [class.active-sidelink]="currentSection === 'lc-rtw'"
                                          >
                                          <a tabindex="0" (click)="scrollToSection('lc-rtw')"
                                            >{{ 'Returning to Work' | translation: translationRequest }}</a
                                            >
                                          </div>
                                        }
                                        @if (isThingsToKnow) {
                                          <div
                                            class="app-lc-sticky-link"
                                            [class.active-sidelink]="currentSection === 'lc-things'"
                                            >
                                            <a tabindex="0" (click)="scrollToSection('lc-things')"
                                              >{{ 'Things to Know' | translation: translationRequest }}</a
                                              >
                                            </div>
                                          }
                                        </div>
                                      </app-sticky-menu>
                                    </div>
                                  </div>
    `,
    styles: [
        `
      .active-sidelink {
        background-color: var(--sed-grey-60-color) !important;
        color: unset !important;
        color: var(-sed-dynamic-black-color) !important;
        text-decoration: underline !important;
        text-decoration-thickness: 3px !important;
        text-decoration-color: var(-sed-dynamic-black-color) !important;
      }
      .app-lc-menu {
        border-left: 1px solid var(--color-light-grey);
        padding-left: 16px;
        margin-left: 16px;
      }
      .left-wrap {
        float: left;
      }
      .right-wrap {
        float: right;
      }
      .img-pd-btm {
        padding-bottom: 95px;
      }
      .center {
        text-align: center;
      }
      .mat-icon {
        margin: auto;
      }
      p + p {
        margin-top: 10px;
      }

      .documents-routing {
        visibility: hidden !important;
        display: none !important;
      }

      li:empty {
        display: none;
      }
    `,
    ],
    standalone: false
})
export class LearningCenterWcComponent implements OnInit, AfterViewInit {
  @Input()
  isMgr: boolean;

  @Input()
  learningCenter: any;

  @Input()
  loading: boolean;
  isShown: boolean = false;
  @Input()
  claimClosed: boolean;

  scrollToElement = scrollToElement;
  @Input()
  lcType: string;

  @Input()
  translationRequest: TranslationRequest;
  
  isOpenfile: boolean = false;
  documentUrl: string;
  mappings: any = [];

  isIntroduction: boolean = false;
  isWhatisWC: boolean = false;
  isBenefitsCalc: boolean = false;
  isWhatsNext: boolean = false;
  isMedical: boolean = false;
  isReturnToWork: boolean = false;
  isThingsToKnow: boolean = false;
  currentSection: string = 'lc-intro';

  @ViewChild('dynamicContentContainer') container: ElementRef;
  @ViewChild('stickyMenu') stickyMenu!: StickyMenuComponent;
  private unlistens: (() => void)[] = [];
  constructor(
    private session: Session,
    public learningCenterService: LearningCenterService,
    private dialog: MatDialog,
    public openFileService: OpenFileService,
    public router: Router,
    private bindEvents: DynamicEventBindService,
    public claimConfigService: ConfigurationService,
    private logService: LogService
  ) {}

  subs = new SubSink();

  async ngOnInit() {
    this.checkHeaderValues();
    this.mappings = [
      {
        selector: '.report-new-claim',
        action: this.reportClaim.bind(this),
      },
      {
        selector: '.medical-provider',
        action: this.openFileLink.bind(this),
      },
      {
        selector: '.go-to-personal-notif',
        route: '/PreferencesPage',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-comm-center',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'comm-center',
        },
      },
      {
        selector: '.go-to-pharmacy-card',
        route: '/pharmacy-card',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-documents-upload',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: true,
        },
      },
      {
        selector: '.go-to-documents',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'DOCUMENTS',
        },
      },
      {
        selector: '.go-to-documents-show',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: false,
        },
      },
    ];
    this.checkViaClaim();
    await this.claimConfigService.initializeConfig();
  }

  ngAfterViewInit() {
    //angular's innerHTML attribute doesnt bind click events so have to do this
    if (this.mappings?.length) {
      this.unlistens = this.bindEvents.bindDynamicEvents(
        this.container,
        this.mappings
      );
    }
  }

  openFileLink(event: MouseEvent) {
    event.preventDefault();
    const dialogRef = this.dialog.open(ExternalLinkDialogComponent);
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.openFileService.openfile();
        this.logService.LogFeatureWithClaim(
          this.learningCenter.claimInfo,
          'Find a Doctor',
          'Learning Center'
        );
      }
    });
  }

  reportClaim(event: MouseEvent) {
    event.preventDefault();
    reportNewClaim(this.dialog);
  }

  checkViaClaim() {
    if (this.learningCenter.claimInfo.claimId != null) {
      this.isShown = !this.isShown;
    }
  }

  redirectToDocUpload() {
    this.router.navigate(['../upload-documents-in-documentstab'], {
      queryParams: {
        source: this.learningCenter.claimInfo.source,
        claimId: this.learningCenter.claimInfo.claimId,
        focus: 'documents',
        showDialog: true,
      },
    });
  }

  ngOnDestroy(): void {
    this.unlistens.forEach((unlisten) => unlisten());
    this.subs.unsubscribe();
  }
  checkHeaderValues() {
    if (this.checkArrayValue(this.learningCenter.introductionResults, 0)) {
      this.isIntroduction = true;
    }
    if (this.checkArrayValue(this.learningCenter.introductionResults, 2)) {
      this.isWhatisWC = true;
    }
    if (this.checkArrayValue(this.learningCenter.benefits, 0)) {
      this.isBenefitsCalc = true;
    }
    if (this.checkArrayValue(this.learningCenter.whatsnexts, 0)) {
      this.isWhatsNext = true;
    }

    if (
      this.checkArrayValue(this.learningCenter.medicaltreatmentandproviders, 0)
    ) {
      this.isMedical = true;
    }

    if (this.checkArrayValue(this.learningCenter.returntoworks, 1)) {
      this.isReturnToWork = true;
    }

    if (this.checkArrayValue(this.learningCenter.thingstoknows, 0)) {
      this.isThingsToKnow = true;
    }
  }

  checkArrayValue(arr: any[], index: number) {
    const arrVal = arr.slice();
    if (index > 0) {
      arrVal.splice(index - 1, 1);
      return arrVal.some((obj) => obj.value !== '');
    } else {
      return arrVal.some((obj) => obj.value !== '');
    }
  }

  onSectionChange(section: string) {
    this.currentSection = section;
  }

  scrollToSection(sectionId: string) {
    this.stickyMenu.scrollToSection(sectionId);
  }
}
